export const provinces = [
  {
    id: '0',
    label: 'CABA',
  },
  {
    id: '1',
    label: 'Buenos Aires',
  },
  {
    id: '2',
    label: 'Catamarca',
  },
  {
    id: '3',
    label: 'Chaco',
  },
  {
    id: '4',
    label: 'Chubut',
  },
  {
    id: '5',
    label: 'Cordoba',
  },
  {
    id: '6',
    label: 'Corrientes',
  },
  {
    id: '7',
    label: 'Entre Rios',
  },
  {
    id: '8',
    label: 'Formosa',
  },
  {
    id: '9',
    label: 'Jujuy',
  },
  {
    id: '10',
    label: 'La Pampa',
  },
  {
    id: '11',
    label: 'La Rioja',
  },
  {
    id: '12',
    label: 'Mendoza',
  },
  {
    id: '13',
    label: 'Misiones',
  },
  {
    id: '14',
    label: 'Neuquen',
  },
  {
    id: '15',
    label: 'Rio Negro',
  },
  {
    id: '16',
    label: 'Salta',
  },
  {
    id: '17',
    label: 'San Juan',
  },
  {
    id: '18',
    label: 'San Luis',
  },
  {
    id: '19',
    label: 'Santa Cruz',
  },
  {
    id: '20',
    label: 'Santa Fe',
  },
  {
    id: '21',
    label: 'Santiago del Estero',
  },
  {
    id: '22',
    label: 'Tierra del Fuego',
  },
  {
    id: '23',
    label: 'Tucuman',
  },
];
